import getImageSize from "@store/Framework/Common/Utilities/getImageSize";
import { pxToRem, pxToRemArray } from "@store/Framework/Common/Utilities/unitHelper";
import Styleguide from "@store/Framework/Types/Styleguide";

const design: Styleguide["design"] = {
    accordion: {
        padding: {
            horizontal: pxToRemArray([20, null, 24, 28]),
            vertical: pxToRemArray([12, null, 14, 16]),
        },
        spacing: pxToRemArray([2, null, 4, 8]),
    },
    autocomplete: {
        link: {
            color: "inherit",
            hoverColor: "text.linkAltHover",
            underline: false,
            hoverUnderline: true,
        },
    },
    button: {
        field: {
            enabled: false,
            scaling: 0,
        },
    },
    category: {
        image: {
            small: getImageSize(768),
            large: getImageSize(1410, 550),
        },
    },
    form: {
        actions: {
            gap: pxToRem(8),
            spacing: "1.5em",
        },
        grid: {
            small: {
                horizontal: pxToRemArray([20]),
                vertical: ["0.75em"],
            },
            base: {
                horizontal: pxToRemArray([30]),
                vertical: ["1em"],
            },
        },
    },
    layout: {
        contentWidth: 1410,
        spacing: {
            side: pxToRemArray([20, 30, 45, null, 60]),
            content: pxToRemArray([25, 30, 45, null, 60]),
            narrowContent: pxToRemArray([25, 30, 40, null, 50]),
        },
    },
    header: {
        breakpoint: "md",
        height: pxToRemArray([75, null, 90, 100, 110]),
        padding: pxToRemArray([15]),
        itemSpacing: pxToRemArray([2, null, 30, 40, 50]),
        subItemSpacing: pxToRemArray([2, null, 20, 25, 30]),
        iconButton: {
            size: pxToRemArray([30, null, 40]),
            padding: pxToRemArray([5, null, 0]),
        },
    },
    menu: {
        panel: {
            rowPadding: pxToRem(16),
        },
        mainNavigation: {
            height: pxToRemArray([45, null, null, 50]),
            megaMenuFullWidth: true,
            underlineSize: pxToRem(4),
        },
        secondaryNavigation: {
            height: pxToRemArray([45]),
            itemSpacing: pxToRem(30),
            iconSpacing: pxToRem(7),
            separatorSize: pxToRem(0),
        },
        megaMenuWithTabs: {
            minHeight: pxToRem(350),
            spacing: pxToRem(30),
            tabs: {
                childSpacing: pxToRem(14, 24, 14, 15),
                spacingLeft: pxToRem(36),
                width: pxToRemArray([null, null, 288, 328, 376]),
            },
            tabsContent: {
                spacing: pxToRem(43, 68),
            },
        },
    },
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
        detail: {
            contentSpacing: pxToRem(16),
        },
        list: {
            contentSpacing: pxToRem(10),
        },
    },
    typography: {
        fontFamily: {
            title: `Titillium Web`,
            base: `Titillium Web`,
        },
        letterSpacing: {
            base: pxToRem(0),
            large: pxToRem(0.5),
            larger: pxToRem(1),
        },
        lineHeight: {
            smaller: 1,
            small: 1.25,
            semi: 1.375,
            base: 1.5,
            large: 1.75,
            larger: 2,
        },
        size: {
            tiny: pxToRem(12),
            smallest: pxToRem(13),
            smaller: pxToRem(14),
            small: pxToRem(15),
            base: pxToRem(16),
            large: pxToRem(18),
            larger: pxToRem(21),
        },
        spacing: {
            smaller: "0.25em",
            small: "0.5em",
            base: "1em",
            large: "1.5em",
            larger: "2em",
        },
        weight: {
            thin: 100,
            extralight: 200,
            light: 300,
            base: 400,
            medium: 500,
            semibold: 600,
            bold: 700,
            extrabold: 800,
            black: 900,
        },
    },
};

export default design;
